// Resolution of a content record, written "1280x720" (width x height in pixels).
//
// Videos get `width` / `height` from the Cloud Function after transcoding (and from the browser
// at upload); older records may not have them at all. The resolution is NOT taken from the file
// name: names often say something else than the file really is.

// "1280x720" for a record that has a width and a height, otherwise null
export const resolutionKey = (item) => {
  const width = Math.round(Number(item?.width))
  const height = Math.round(Number(item?.height))
  return width > 0 && height > 0 ? `${width}x${height}` : null
}

// "1280x720", "1280 x 720" or "1280×720" -> "1280x720"; null when the text is not a resolution
export const parseResolution = (text) => {
  const match = /^\s*(\d{1,5})\s*[x×*]\s*(\d{1,5})\s*$/i.exec(String(text === undefined || text === null ? '' : text))
  if (!match) return null
  const width = Number(match[1])
  const height = Number(match[2])
  return width > 0 && height > 0 ? `${width}x${height}` : null
}

// A list of resolutions as typed or stored: valid ones only, each once, in the given order
export const normalizeResolutions = (list) => {
  const seen = new Set()
  const result = []
  for (const value of Array.isArray(list) ? list : []) {
    const key = parseResolution(value)
    if (key && !seen.has(key)) {
      seen.add(key)
      result.push(key)
    }
  }
  return result
}

// [{ key, count }] for the resolutions found in `items`, the most used first
export const resolutionCounts = (items) => {
  const counts = new Map()
  for (const item of items || []) {
    const key = resolutionKey(item)
    if (key) counts.set(key, (counts.get(key) || 0) + 1)
  }
  return [...counts].map(([key, count]) => ({ key, count })).sort((a, b) => b.count - a.count || a.key.localeCompare(b.key, undefined, { numeric: true }))
}

// No resolutions chosen means "any". Otherwise a video AND a picture have to be one of them,
// and content without a known resolution matches none (the broadcast forms have "Show all content").
export const matchesResolutions = (item, resolutions) => !resolutions || resolutions.length === 0 || resolutions.includes(resolutionKey(item))

// Number of pixels of "1280x720" (for sorting by size); 0 when it is not a resolution
export const resolutionArea = (key) => {
  const parsed = parseResolution(key)
  if (!parsed) return 0
  const [width, height] = parsed.split('x').map(Number)
  return width * height
}
